export enum PAGE_CONSTANTS {
    Components = 'COMPS',
    Reimbursements = 'RIMBS',
    ContactHistory = 'CNHIS',
    EmploymentPlan ='EMPPL',
    NonComplianceComponent = 'WCNCO',
    Appointments = 'APPTS',
    CaseNotes = 'CSNTS',
    ClientInformation = 'CLINF',
    Assesment = 'ASMNT',
    CreateTask = 'CRTSK',
    NonComplianceSummary = 'WCNCS',
    NonCompliance = 'NCMPL'   
}


// WEBPACK FOOTER //
// ./src/app/shared/constants/page.constants.ts